import { render, staticRenderFns } from "./SidebarNavLink.vue?vue&type=template&id=6fe393b9&scoped=true&"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js&"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe393b9",
  null
  
)

export default component.exports